/* unplugin-vue-components disabled */import { render } from "./UserAge.vue?vue&type=template&id=6f484841&scoped=true"
import script from "./UserAge.vue?vue&type=script&lang=js"
export * from "./UserAge.vue?vue&type=script&lang=js"

import "./UserAge.vue?vue&type=style&index=0&id=6f484841&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f484841"]])

export default __exports__